import { roleLabels } from "@groundspark/browser-auth";
import { element, table } from "@groundspark/browser-ui";
import type { Member } from "./domain";

const dates = new Intl.DateTimeFormat("en-GB", { dateStyle: "medium" });

export function memberTable(
  members: readonly Member[],
  checkbox?: (member: Member) => HTMLInputElement,
): HTMLElement {
  const headings = ["Name", "Email address", "Phone number", "Groups", "Role", "Joined"];
  if (checkbox !== undefined) headings.unshift("Select");
  return table(
    headings,
    members.map((member) => {
      const cells: (string | Node)[] = [
        element("strong", null, member.displayName),
        member.email,
        member.phoneNumber,
        member.groups.length === 0
          ? "None"
          : element(
              "div",
              "person",
              ...member.groups.map((group) => element("span", null, group.name)),
            ),
        roleLabels[member.role],
        dates.format(member.createdAt),
      ];
      if (checkbox !== undefined) cells.unshift(checkbox(member));
      return { cells };
    }),
  );
}
